import React, { useEffect, useState } from 'react';
import './subscribeBtn.scss';
import { subscribeEamil } from '../../../lib/subscribe';

const SubscribeBtn = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [email, setEmail] = useState<string>();

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await subscribeEamil(email!);
    setEmail('');
  };
  return (
    <div className="main-divide-layout">
      <form onSubmit={onSubmit}>
        <label htmlFor="subscribe">
          <div className="subscribe-box">
            <img src="/seamansclub-news/assets/svg/arrow-down.svg" alt="" className="down-icon" />
            {windowWidth <= 1000 ? (
              <div>
                <div className="subscribe-title">SubScribe Today!</div>
                <div className="subscribe-message">
                  <p className="sub-meg">We are preparing a news letter service.</p>
                  <p className="sub-meg">If you enter your email address,</p>
                  <p className="sub-meg">we will send you an email after the service opens.</p>
                </div>
              </div>
            ) : (
              <>
                <div className="subscribe-title">SubScribe Today!</div>
                <div className="subscribe-message">
                  <p className="sub-meg">We are preparing a news letter service.</p>
                  <p className="sub-meg">If you enter your email address,</p>
                  <p className="sub-meg">we will send you an email after the service opens.</p>
                </div>
              </>
            )}
            <img src="/seamansclub-news/assets/svg/arrow-down.svg" alt="" className="down-icon" />
          </div>
        </label>
        <div className="subscribe-btn-box">
          <input
          value={email}
            type="email"
            id="subscribe"
            placeholder="Enter Your Email Address:D"
            className="email-input"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
          />
          <div className="subscribe-divide"></div>
          <button type="submit" className="subscribe-btn">SUBSCRIBE!</button>
        </div>
      </form>
    </div>
  );
};

export default SubscribeBtn;
